const env = import.meta.env
export const BILL_TYPES_COMPANY_IDS = env.VITE_BILL_TYPE_COMPANY_IDS.split(',').map(Number)
